import XLSX from 'xlsx';

export function generateExcel(report) {
    // console.log(report)
    var doc = GetUnique(report);
    // console.log(doc)
    var wb = XLSX.utils.book_new();

    var ws = XLSX.utils.json_to_sheet([
        { A: "", B: "", C: "", D: "" },
    ], { header: [], skipHeader: true });

    doc.forEach(ele => {

        XLSX.utils.sheet_add_json(ws, [
            {
                A: _selectMonthFull(ele.month)
            }
        ], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [
            {
                A: "VESSELVOY",
                B: "ORIGIN",
                C: "DESTINATION",
                D: "DEPARTURE DATE"
            }
        ], { header: [], skipHeader: true, origin: -1 });

        report.forEach(vs => {
            var date = new Date(vs.estimatedTimeDeparture);
            var month = date.getMonth();
            var day = date.getDate();

            if (day < 10) {
                day = '0' + day;
            }
            if (ele.month === month && ele.mnvessel === vs.vesselName) {
                vs.voyageScheduleDestination.forEach(dest => {
                    XLSX.utils.sheet_add_json(ws, [
                        {
                            A: vs.vesselName + vs.voyageNum,
                            B: vs.originBranchName,
                            C: dest.destinationBranchName,
                            D: _selectMonth(month) + ' ' + day
                        }
                    ], { header: [], skipHeader: true, origin: -1 });
                })
            }
        });

        XLSX.utils.sheet_add_json(ws, [
            { A: "", B: "", C: "", D: "" },
        ], { header: [], skipHeader: true, origin: -1 });

    });

    var wscols = [
        { wch: 25 }, // vesselvoy
        { wch: 20 }, // origin
        { wch: 20 }, // destination
        { wch: 20 }, // date
    ];

    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Voyage Schedule");

    XLSX.writeFile(wb, "voyage_schedule.xlsx")
}

function GetUnique(doc) {
    const result = [];
    var date, month;
    const map = new Map();
    // eslint-disable-next-line
    for (const item of doc) {
        date = new Date(item.estimatedTimeDeparture);
        month = date.getMonth();
        if (!map.has(month && item.vesselName)) {
            map.set(month && item.vesselName, true);    // set any value to Map
            result.push({
                month: month,
                mnvessel: item.vesselName,
            });
        }
    }
    return result;
}

function _selectMonth(m) {
    var nextmonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return nextmonthNames[m];
}
function _selectMonthFull(m) {
    var nextmonthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return nextmonthNames[m];
}